export default {
    data() {
        return {
            eventListeners: [],
        }
    },

    beforeUnmount() {
        this.eventListeners.forEach((hook) => {
            hook.element.removeEventListener(hook.event, hook.handle)
        })
    },

    methods: {
        listen(element, event, handle, options) {
            element.addEventListener(event, handle, options)

            this.eventListeners.push({ element, event, handle })
        },
    },
}
